import React, { useCallback } from 'react'
import links from '~config/links'
import t from '~t'

import { Modal, ModalContent as Content, ModalHeader as Header, Icon, Button } from '~ui';

export default function UserUpgrade({ onClose }) {
    //close on click buy
    const onBuyClick = useCallback(()=>onClose(), [onClose])

    return (
        <Modal 
            className={'ui-upgrade-modal'}
            onClose={onClose}>
            <div className={'ui-upgrade-container'}>
                <div className={'ui-upgrade-intro'}>
                    <Icon className={'ui-upgrade-icon'} name='diamond_active' enlarge='4' />

                    <svg className={'ui-upgrade-noise'} xmlns='http://www.w3.org/2000/svg'>
                        <filter id='noiseFilter'><feTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch' /></filter>
                        <rect width='100%' height='100%' filter='url(#noiseFilter)' />
                    </svg>
                </div>

                <div>
                    <Header 
                        data-no-shadow
                        title={t.s('goPro')} />

                    <Content className={'ui-upgrade-content'}>
                        <p>
                            {t.s('proUnlockDescription')} <a href={links.pro.compare} target='_blank'>{t.s('learnMore')}</a>
                        </p>

                        <h4>{t.s('proIncludes')}</h4>
                        <ul>
                            <li><Icon className={'ui-upgrade-icon'} name='ai' /> {t.s('suggestedCollectionsAndTags')}</li>
                            <li><Icon className={'ui-upgrade-icon'} name='sort_score' /> {t.s('fullTextSearch')}</li>
                            <li><Icon className={'ui-upgrade-icon'} name='export' /> {t.s('webArchive')}</li>
                            <li><Icon className={'ui-upgrade-icon'} name='highlights' /> {t.s('proAnnotations')}</li>
                            <li><Icon className={'ui-upgrade-icon'} name='reminder_add' /> {t.s('reminders')}</li>
                            <li><Icon className={'ui-upgrade-icon'} name='broken' /> {t.s('proDuplicateBroken')}</li>
                            <li><Icon className={'ui-upgrade-icon'} name='sort_-created' /> {t.s('proDailyBackups')}</li>
                        </ul>

                        <p className={'ui-upgrade-more'}>
                            {t.s('proAndMore')}
                        </p>

                        <div className={'ui-upgrade-actions'}>
                            <Button 
                                variant='primary'
                                href={links.pro.buy}
                                target='_blank'
                                onClick={onBuyClick}>
                                {t.s('subscribe')}
                            </Button>
                        </div>
                    </Content>
                </div>
            </div>
        </Modal>
    )
}